import styled from '@emotion/styled';
import shouldForwardProp from '@styled-system/should-forward-prop';
import { variant } from 'styled-system';

import sx, { SxProp } from '../../internal/styles/sx';
import {
  ResponsiveFontWeights,
  ResponsiveHeadings,
} from '../../themes/cobalt/types';
import BaseText, { BaseTextProps } from '../BaseText';

export interface HeadingProps extends SxProp, BaseTextProps {
  weight?: ResponsiveFontWeights;
  type: ResponsiveHeadings;
}

const options = {
  shouldForwardProp: (prop) => shouldForwardProp(prop) && prop !== 'type',
};
const Heading = styled(BaseText, options)<HeadingProps>(
  variant({
    prop: 'weight',
    variants: {
      normal: {
        fontWeight: 'normal',
      },
      medium: {
        fontWeight: 'medium',
      },
      bold: {
        fontWeight: 'bold',
      },
    },
  }),
  variant({
    prop: 'type',
    variants: {
      '1': {
        fontSize: 'headings.1',
        lineHeight: 'headings.1',
        letterSpacing: 'condensed',
      },
      '2': {
        fontSize: 'headings.2',
        lineHeight: 'headings.2',
      },
      '3': {
        fontSize: 'headings.3',
        lineHeight: 'headings.3',
      },
      '4': {
        fontSize: 'headings.4',
        lineHeight: 'headings.4',
      },
      '5': {
        fontSize: 'headings.5',
        lineHeight: 'headings.5',
      },
      '6': {
        fontSize: 'headings.6',
        lineHeight: 'headings.6',
      },
    },
  }),
  { display: 'block' },
  sx
);

export default Heading;
